/**
 * @description: 所在楼层选择框选项
 */
export const floorOptions = [
  {
    value: '1',
    label: '一层',
  },
  {
    value: '2',
    label: '二层',
  },
  {
    value: '3',
    label: '三层',
  },
  {
    value: '4',
    label: '四层',
  },
  {
    value: '5',
    label: '五层',
  },
  {
    value: '6',
    label: '六层',
  },
  {
    value: '-1',
    label: '负一层',
  },
  {
    value: '-2',
    label: '负二层',
  },
  {
    value: '-3',
    label: '负三层',
  },
]

/**
 * @description: 硬编解码营业时间码率选择框选项
 */
export const bitrateOptions = [
  {
    value: 512,
    label: '512K',
  },
  {
    value: 768,
    label: '768K',
  },
  {
    value: 1024,
    label: '1M',
  },
  {
    value: 1500,
    label: '1.5M',
  },
]

/**
 * @description: 非营业时间码率选项
 */
export const closedtimeBitrateOptions = [
  {
    value: 150,
    label: '150K',
  },
  {
    value: 300,
    label: '300K',
  },
  ...bitrateOptions,
]
